import React,{ useState,useEffect } from 'react';
import MenuExteriorView from './MenuExteriorView';
import MenuInterierView from './MenuInterierView';
import AnimationBtn from './AnimationBtn';
import MenuSoftware from './MenuSoftware';
import Howtousenew from './Howtousenew';
import MenuSelectProductType from './MenuSelectProduct';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';

// import MenuBtn from './MenuBtn';
// import { MicNone } from '@material-ui/icons';
var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

export const userContext = React.createContext();
var prevCounter = 0;
var nextClicked = false;
var prevClicked = false;
var buttonSeq = ['onResetMode','onExteriorClick','FrontModeClick','RearModeClick','onInterirorClick','onProcessorClick','onMemoryClick','onFanClick','onSoftwareClick','embeddedManagementClick','openManageToolsClick','ondataOptClick','dataMobilityClick','dataProtectionClick','virtualizationClick'];

// var buttonSeq180 = ['onResetMode', 'onFrontClick', 'onTopClick', 'onRightClick', 'onLeftClick', 'openCloseClick', 'backliteClick'];
var selectedButton = 'onResetMode';

const MainMenu = (props) => {
   const [expandedPanel,setExpandedPanel] = useState(false);
   const [frontImg,setfrontImg] = useState("./img/front.png");
   const [rearImg,setrearImg] = useState("./img/rear.png");
   const [storageProcessorImg,setstorageProcessorImg] = useState("./img/storageProcessor.png");
   const [controllerMemoryImg,setcontrollerMemoryImg] = useState("./img/controllerMemory.png");
   const [portImg,setPortImg] = useState("./img/back_white.png");
   const [monitorPivotImg,setMonitorPivotImg] = useState("./img/pilot_white.png");
   const [monitorSwivelImg,setMonitorSwivelImg] = useState("./img/swivel_white.png");
   const [monitorHeightImg,setMonitorHeightImg] = useState("./img/height_white.png");
   const [monitorTiltImg,setMonitorTiltImg] = useState("./img/tilt_white.png");
   const [monitorColorometerImg,setMonitorColorometerImg] = useState("./img/colorometer_white.png");
   const [monitorHoodImg,setMonitorHoodImg] = useState("./img/hood_white.png");

   //   const [orientationPotrait, setOrientation] = useState(true);
   //   window.checkOrientationStatus = (orientationStatus) => 
   //   {
   //   //  alert(window.screen.orientation.type);
   //     setOrientation(orientationStatus);
   //  }

   const handleAccordionChange = (panel) => (event,isExpanded) => {
      console.log({ event,isExpanded });
      //setExpandedPanel(isExpanded ? panel  : false );
      if (isExpanded) {
         setExpandedPanel(panel);
         //console.log("shubham");
      } else {
         //  console.log("Pawar");
         setExpandedPanel(false)
      };
      // resetBacklitCloseImg();

   };
   const [camData,setCamData] = useState("");
   var animationSwitch = window.localStorage.getItem('Animation');
   var animTime = 1;
   var animTimes = 1;

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            // console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      //   window.getLangTranscript();
      animationSwitch = window.localStorage.getItem('Animation');
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      //window.localStorage.setItem('tent', false);
      //window.localStorage.setItem('tablet', false);
      //window.localStorage.setItem('theater', false);
      //window.localStorage.setItem('close', false);
      window.localStorage.setItem("position","reset");
      
      window.addEventListener('mousedown',() => {
         // document.getElementById('calloutcanvas').style.display = "none";
         window.localStorage.removeItem('hotspot');
      })

      return () => {
         window.removeEventListener('mousedown',() => {
            // document.getElementById('calloutcanvas').style.display = "none";
            window.localStorage.removeItem('hotspot');
         })
      }
   },[]);

   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   },[])
   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }
      //     var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

      // let mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   })
   const [animStoped,setanimStoped] = useState(true);

   const animComplete = () => {
      setanimStoped(true);
      var g_navEnabled = true;
      // document.getElementById("onReset").style.pointerEvents = "all";
   }

   //For Animation Switch 
   // console.log('animationSwitch anim', animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }
   // console.log('animTime', animTime)

   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      // below code is updated in it.  
      // updated code ends here

      var opt = undefined,gp = camData[gotoposname];

      //    console.log(gp)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      // console.log('animationSwitch', animationSwitch)
      if (animationSwitch == 'off') {
         gp.time = 1
         // console.log('animationSwitch iffff', gp.time)
      }
      else {
         gp.time = animTime;
         // console.log('animationSwitch elseeee', gp.time)
      }
      console.log('animationSwitch',animationSwitch);
      console.log('gp.time',gp.time);
      window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4],gp.time,onComplete,slowInOut,opt);
      // console.log(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
   }
   //end
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }



   const interiorAnim = () => {
      window.scene.animPlayInTime("Internal_Cover_Anim",1,animTime);
      window.scene.animPlayInTime("Front_Net_B_Anim",1,animTime);
      window.scene.animPlayInTime("HDD38",1,animTime);
      window.scene.animPlayInTime("pasted__HDD39",1,animTime);
      window.scene.animPlayInTime("Fan_01",1,animTime);
      window.scene.animPlayInTime("Fan_02",1,animTime);
      window.scene.animPlayInTime("Fan_03",1,animTime);
      window.scene.animPlayInTime("Fan_04",1,animTime);
      window.scene.animPlayInTime("Fan_05",1,animTime);
      window.scene.animPlayInTime("Fan_06",1,animTime);
      window.scene.animPlayInTime("Ram_Anim",1,animTime);
      window.scene.animPlayInTime("Heatsink_Anim",1,animTime);
      window.scene.clearRefine();
   }

   const reverseAnim = () => {
      window.scene.animPlayInTime("DELL_POWER_VAULT_4591",0.04,1000);
      window.scene.animPlayInTime("BEZEL",0.04,1000);
      window.scene.groupApplyState("Top_ON");
      window.scene.groupApplyState("Internal_24_NEW_OFF");
      window.scene.groupApplyState("Internal_12_NEW_OFF");
      window.scene.clearRefine();
   }
   const reverseState = () => {
      window.scene.groupApplyState("Top_Cover_Unhide");
      window.scene.groupApplyState("Front_Net_B_ON");
      window.scene.groupApplyState("cover_unhide");
      window.scene.groupApplyState("Internal_Unhide");
      window.scene.groupApplyState("cover_unhide");
      window.scene.groupApplyState("Front_Net_B_refle_ON");

   }
   const hideSoftwareImg = () => {
      document.getElementById("openManagmentTool").style.display = 'none';
      document.getElementById("dataMobilityTitleDiv").style.display = 'none';
      document.getElementById("dataOptimizaion").style.display = 'none';
      document.getElementById("embadedManagment").style.display = 'none';
      document.getElementById("dataProtectionTitleDiv").style.display = 'none';
      document.getElementById("virtualizationTitleDiv").style.display = 'none';
      document.getElementById('performance').style.display = 'none';
      document.getElementById('controller_memory').style.display = 'none';
      document.getElementById('storage_processor').style.display = 'none';
   }
   //MenuExterioeView

   const onExteriorClick = (isNextPrevious) => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      hideSoftwareImg();
      // document.getElementById('exteriorViewBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();

      selectedButton = 'onExteriorClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Exterior view');

         document.getElementById('nextView').setAttribute('aria-label','Exterior view');
      }

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
         window.scene.groupApplyState("Power_Vault_12_ON");
         
      }
      else if(server2){
         window.scene.groupApplyState("Top_OFF");
         window.scene.groupApplyState("Power_Vault_12_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
         window.scene.groupApplyState("Power_Vault_12_OFF");
      } 


      if(server1){
         GotoPosInTimeNamedValue(window.config.default,function ()  {
         });
         
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.default,function ()  {
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.default5U,function ()  {
         });
      } 
      


      window.scene.clearRefine();

   }

   const FrontModeClick = (isNextPrevious) => {

      
      //Update ZoomBar
      // window.scene.groupApplyState("Front_Net_A_ON");
      console.log("front");

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      hideSoftwareImg();
      window.document.getElementById('frontBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();
      // document.getElementById('calloutcanvas').style.display = "none";
      selectedButton = 'FrontModeClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Front');

         document.getElementById('nextView').setAttribute('aria-label','Front');
      }

      window.localStorage.removeItem('hotspot');

      window.scene.clearRefine();
      if(server1){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
      } 
        if(server1){
            GotoPosInTimeNamedValue(window.config.front,function () {
          
            window.scene.groupApplyState("Top_ON");
            window.scene.groupApplyState("Front_Panel_OFF");
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
               //window.document.getElementById("hotspot1demo2").focus();
               // window.// document.getElementById('calloutcanvas').style.display = "block";
            }
            window.localStorage.setItem('hotspot','front1');
         });
         }
         else if(server2){
            GotoPosInTimeNamedValue(window.config.front,function () {
               window.document.getElementById("hotspot1demo").focus();
              // window.document.getElementById("hotspot1demo2").focus();
            // // document.getElementById('calloutcanvas').style.display = "block";
            window.localStorage.setItem('hotspot','front2');
            window.scene.groupApplyState("Top_ON");
            window.scene.groupApplyState("Front_Panel_OFF");
         });
         }
         else if(server3){
            GotoPosInTimeNamedValue(window.config.front5U,function () {
               window.document.getElementById("hotspot1demo").focus();
               //window.document.getElementById("hotspot1demo2").focus();
            // // document.getElementById('calloutcanvas').style.display = "block";
            window.localStorage.setItem('hotspot','front3');
            window.scene.groupApplyState("Top_OFF");
         });
         }         
         
         // if (isNextPrevious != true) {
         //    window.document.getElementById("hotspot1demo").focus();
         //   // window.document.getElementById("hotspot1demo2").focus();
         // }
      

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","1");
         document.getElementById("hotspot2").setAttribute("tabindex","1");
         document.getElementById("hotspot3").setAttribute("tabindex","1");
         document.getElementById("hotspot4").setAttribute("tabindex","1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Exterior","Front",window.config.name);
      window.scene.clearRefine();

   }

   const RearModeClick = (isNextPrevious) => {

      console.log("back");

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      console.log("interirer")
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      hideSoftwareImg();
      window.document.getElementById('rearBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();

      selectedButton = 'RearModeClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Rear');

         document.getElementById('nextView').setAttribute('aria-label','Rear');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
      }    


      
         
         if(server1){
            GotoPosInTimeNamedValue(window.config.back,function ()  {
            // document.getElementById('calloutcanvas').style.display = "block";
            window.localStorage.setItem('hotspot','rear1');
            window.scene.groupApplyState("Front_Panel_ON");
         });
         }
         else if(server2){
            GotoPosInTimeNamedValue(window.config.back,function ()  {
            // document.getElementById('calloutcanvas').style.display = "block";
            window.localStorage.setItem('hotspot','rear2');
            window.scene.groupApplyState("Front_Panel_ON");
         });
         }
         else if(server3){
            GotoPosInTimeNamedValue(window.config.back5U,function ()  {
            // document.getElementById('calloutcanvas').style.display = "block";
            window.localStorage.setItem('hotspot','rear3');
         });
         }    
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","1");
         document.getElementById("hotspot6").setAttribute("tabindex","1");
         document.getElementById("hotspot7").setAttribute("tabindex","1");
         document.getElementById("hotspot8").setAttribute("tabindex","1");
         document.getElementById("hotspot9").setAttribute("tabindex","1");
         document.getElementById("hotspot10").setAttribute("tabindex","1");
         document.getElementById("hotspot11").setAttribute("tabindex","1");
         document.getElementById("hotspot12").setAttribute("tabindex","1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Exterior","Rear",window.config.name);

      window.scene.clearRefine();

   }



   //Menu Interier
   const onInterirorClick = (isNextPrevious) => {

      //Update ZoomBar

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      hideSoftwareImg();

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      // window.document.getElementById('dimensionsBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();

      selectedButton = 'onInterirorClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Interier');

         document.getElementById('nextView').setAttribute('aria-label','Interier');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
         window.scene.groupApplyState("Front_Panel_ON");
         window.scene.groupApplyState("Power_Vault_12_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_OFF");
         window.scene.groupApplyState("Front_Panel_ON");
         window.scene.groupApplyState("Power_Vault_12_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
         window.scene.groupApplyState("Power_Vault_12_OFF");
      } 

      if(server1){
         GotoPosInTimeNamedValue(window.config.internal,function ()  {
         });
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.internal,function ()  {
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.internal5U,function ()  {
         });
      } 
      

      window.scene.clearRefine();

   }

   const onProcessorClick = (isNextPrevious) => {

      console.log("processor");
      //reverseAnim();
      reverseState();
      window.document.getElementById('performance').style.display = 'none';
      window.document.getElementById('controller_memory').style.display = 'none';
      window.document.getElementById('storage_processor').style.display = 'none';
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      hideSoftwareImg();
      window.document.getElementById('processorBtn').classList.add('active');
      window.localStorage.setItem("position","reset");


      selectedButton = 'onProcessorClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Processor');

         document.getElementById('nextView').setAttribute('aria-label','Processor');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');
      
         if(server1){
            GotoPosInTimeNamedValue(window.config.right,function () {
            window.scene.animPlayInTime("DELL_POWER_VAULT_4591",0.41,1000);
            window.scene.groupApplyState("Internal_24_NEW_OFF");
            window.scene.groupApplyState("Internal_12_NEW_ON");
            window.scene.animPlayInTime("BEZEL",0.41,1000);
            window.scene.groupApplyState("Server_OFF");
            setTimeout(function () { 
               window.scene.groupApplyState("Top_OFF");
             },1000);
             document.getElementById('performance').style.display = 'block';
             if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         }
         else if(server2){
            GotoPosInTimeNamedValue(window.config.right,function () {
            window.scene.animPlayInTime("DELL_POWER_VAULT_4591",0.41,1000);
            window.scene.animPlayInTime("BEZEL",0.41,1000);
            window.scene.groupApplyState("Internal_12_NEW_OFF");
            window.scene.groupApplyState("Internal_24_NEW_ON");
            window.scene.groupApplyState("Server_OFF");
            setTimeout(function () { 
               window.scene.groupApplyState("Top_OFF");
             },1000);
             document.getElementById('performance').style.display = 'block';
             if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         }
         else if(server3){
            GotoPosInTimeNamedValue(window.config.right5U,function () {
            window.scene.groupApplyState("Server_ON");
            window.scene.groupApplyState("Top_OFF");
            document.getElementById('performance').style.display = 'block';
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         } 
         
         
         ///window.localStorage.setItem('hotspot','processor');
         

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Interior","Processor",window.config.name);

      window.scene.clearRefine();

   }


   const onMemoryClick = (isNextPrevious) => {

      console.log("controller memory");
      //Update ZoomBar
      //reverseAnim();
      reverseState();
      document.getElementById('performance').style.display = 'none';
      document.getElementById('controller_memory').style.display = 'none';
      document.getElementById('storage_processor').style.display = 'none';
      window.scene.groupApplyState("Top_Cover_Hide");
      window.scene.groupApplyState("cover_Hide");
      window.scene.animPlayInTime("Heatsink_Anim",0,1);
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      hideSoftwareImg();
      window.document.getElementById('memoryBtn').classList.add('active');
      window.localStorage.setItem("position","reset");

      selectedButton = 'onMemoryClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Memory');

         document.getElementById('nextView').setAttribute('aria-label','Memory');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      window.scene.clearRefine();


      
         if(server1){
            GotoPosInTimeNamedValue(window.config.memory,function () {
               document.getElementById('controller_memory').style.display = 'block';
            window.scene.animPlayInTime("DELL_POWER_VAULT_4591",0.41,1000);
            window.scene.groupApplyState("Internal_24_NEW_OFF");
            window.scene.groupApplyState("Internal_12_NEW_ON");
            window.scene.animPlayInTime("BEZEL",0.41,1000);
            window.scene.groupApplyState("Server_OFF");
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         }
         else if(server2){
            GotoPosInTimeNamedValue(window.config.memory,function () {
               document.getElementById('controller_memory').style.display = 'block';
            window.scene.animPlayInTime("DELL_POWER_VAULT_4591",0.41,1000);
            window.scene.groupApplyState("Internal_12_NEW_OFF");
            window.scene.groupApplyState("Internal_24_NEW_ON");
            window.scene.animPlayInTime("BEZEL",0.41,1000);
            window.scene.groupApplyState("Server_OFF");
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         }
         else if(server3){
            GotoPosInTimeNamedValue(window.config.memory5U,function () {
               document.getElementById('controller_memory').style.display = 'block';
            window.scene.groupApplyState("Server_ON");
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         } 
         

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Interior","Memory",window.config.name);

      window.scene.clearRefine();

   }
   const [value,setValue] = useState('server1');
   //MenuSelectProduct
   const [server2,setserver2] = useState(false);

   const [server1,setserver1] = useState(true);

   const [server3,setserver3] = useState(false);
   

   const server1Click = (event) => {

      setserver1(true);
      setserver2(false);
      setserver3(false);
      console.log("server1");
      setfrontImg("./img/front.png");
      setrearImg("./img/rear.png");
      setstorageProcessorImg("./img/storageProcessor.png");
      setcontrollerMemoryImg("./img/controllerMemory.png");
      // setCounter(0);
      console.log(event.target.value);
      setValue(event.target.value);
      reverseAnim();
      hideSoftwareImg();
      // setDisplayed(true);
      // setExpandedPanel(false);
      // setHidden(false);
      window.document.getElementById('performance').style.display = 'none';
      window.document.getElementById('controller_memory').style.display = 'none';
      window.document.getElementById('storage_processor').style.display = 'none';
      selectedButton = 'server1Click';
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');

      // if (alreadySelected != null) {
      //    alreadySelected.classList.remove('active');
      // }

      // document.getElementById('server1').setAttribute('aria-label','2U ME5012 radio butoon selected');
      window.localStorage.setItem("position","reset");
      window.localStorage.setItem("laptop","server1");
      window.localStorage.removeItem('color');


      // nextSibling2.classList.add('PrivateRadioButtonIcon-checked-16')
      document.getElementById("server1").tabIndex = 1;

      window.localStorage.removeItem('hotspot');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      
      window.RT_RecordEvent("Product Type","2U ME5012",window.config.name);
      window.scene.groupApplyState("Power_Vault_24_OFF");
      window.scene.groupApplyState("Power_Vault_12_ON");
      window.scene.groupApplyState("Ref_Vault_12");
      window.scene.groupApplyState("GP_12");
      window.scene.groupApplyState("Front_Panel_ON");
      window.scene.groupApplyState("HDD_2_ON");
      GotoPosInTimeNamedValue(window.config.default,function () {
         // document.getElementById('calloutcanvas').style.display = "block";
      
      });

      document.getElementById("hotspot1").setAttribute("tabindex","-1");


      document.getElementById("hotspot2").setAttribute("tabindex","-1");
      document.getElementById("hotspot3").setAttribute("tabindex","-1");
      document.getElementById("hotspot4").setAttribute("tabindex","-1");
      document.getElementById("hotspot5").setAttribute("tabindex","-1");
      document.getElementById("hotspot6").setAttribute("tabindex","-1");
      document.getElementById("hotspot7").setAttribute("tabindex","-1");
      document.getElementById("hotspot8").setAttribute("tabindex","-1");
      document.getElementById("hotspot9").setAttribute("tabindex","-1");
      document.getElementById("hotspot10").setAttribute("tabindex","-1");

      document.getElementById("hotspot11").setAttribute("tabindex","-1");
      document.getElementById("hotspot12").setAttribute("tabindex","-1");
      document.getElementById("hotspot13").setAttribute("tabindex","-1");
   }



   const server2Click = (event) => {
      setserver2(true);
      setserver1(false);
      setserver3(false);
      console.log("server2");

      setfrontImg("./img/front5024.png");
      setrearImg("./img/rear5024.png");
      setstorageProcessorImg("./img/storageProcessor5024.png");
      setcontrollerMemoryImg("./img/controllerMemory5024.png");
      reverseAnim();
      hideSoftwareImg();
      selectedButton = 'server2Click';
      console.log(event.target.value);
      setValue(event.target.value);
      window.document.getElementById('performance').style.display = 'none';
      window.document.getElementById('controller_memory').style.display = 'none';
      window.document.getElementById('storage_processor').style.display = 'none';
      // setDisplayed(false);
      // setHidden(true);
      // setExpandedPanel(false);
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('server2').setAttribute('aria-label','2U ME5084 radio butoon selected');
      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }


      window.localStorage.removeItem('hotspot');
      // window.scene.groupApplyState("Power_Vault_24_ON");
      // window.scene.groupApplyState("Server_OFF");
      // window.scene.groupApplyState("Power_Vault_12_OFF");
      window.localStorage.setItem("position","reset");


      window.localStorage.setItem("laptop","server2");
      window.localStorage.removeItem('hotspot');


      window.localStorage.removeItem('color');
      document.getElementById("server2").tabIndex = 1;


      window.RT_RecordEvent("Product Type","2U ME5084",window.config.name);
      //add for tab issues
         window.scene.groupApplyState("Power_Vault_12_ON");
         window.scene.groupApplyState("Power_Vault_24_ON");
         window.scene.groupApplyState("Ref_Vault_24");
         window.scene.groupApplyState("GP_24");
         window.scene.groupApplyState("Front_Panel_ON");
         window.scene.groupApplyState("HDD_2_OFF");
      GotoPosInTimeNamedValue(window.config.default,function () {
      });

      document.getElementById("hotspot1").setAttribute("tabindex","-1");
      document.getElementById("hotspot2").setAttribute("tabindex","-1");
      document.getElementById("hotspot3").setAttribute("tabindex","-1");
      document.getElementById("hotspot4").setAttribute("tabindex","-1");
      document.getElementById("hotspot5").setAttribute("tabindex","-1");
      document.getElementById("hotspot6").setAttribute("tabindex","-1");
      document.getElementById("hotspot7").setAttribute("tabindex","-1");
      document.getElementById("hotspot8").setAttribute("tabindex","-1");
      document.getElementById("hotspot9").setAttribute("tabindex","-1");
      document.getElementById("hotspot10").setAttribute("tabindex","-1");

      document.getElementById("hotspot11").setAttribute("tabindex","-1");
      document.getElementById("hotspot12").setAttribute("tabindex","-1");
      document.getElementById("hotspot13").setAttribute("tabindex","-1");


   }

   const server3Click = (event) => {

      setserver2(false);
      setserver1(false);
      setserver3(true);
      console.log("server3");
      setfrontImg("./img/front5084.png");
      setrearImg("./img/rear5084.png");
      setstorageProcessorImg("./img/storageProcessor5084.png");
      setcontrollerMemoryImg("./img/controllerMemory5084.png");
      selectedButton = 'server3Click';
      reverseAnim();
      hideSoftwareImg();
      console.log(event.target.value);
      setValue(event.target.value);
      window.document.getElementById('performance').style.display = 'none';
      window.document.getElementById('controller_memory').style.display = 'none';
      window.document.getElementById('storage_processor').style.display = 'none';
      // setDisplayed(false);
      // setHidden(true);
      // setExpandedPanel(false);
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('server2').setAttribute('aria-label','5U ME5084 radio butoon selected');
      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }


      window.localStorage.removeItem('hotspot');
      // window.scene.groupApplyState("Power_Vault_24_ON");
      // window.scene.groupApplyState("Server_OFF");
      // window.scene.groupApplyState("Power_Vault_12_OFF");
      window.localStorage.setItem("position","reset");


      window.localStorage.setItem("laptop","server3");
      window.localStorage.removeItem('hotspot');


      window.localStorage.removeItem('color');
      document.getElementById("server3").tabIndex = 1;


      window.RT_RecordEvent("Product Type","5U ME5084",window.config.name);
      //add for tab issues
      window.scene.groupApplyState("Server_ON");
      window.scene.groupApplyState("Power_Vault_24_OFF");
      window.scene.groupApplyState("Power_Vault_12_OFF");
      window.scene.groupApplyState("GP_Server");
      window.scene.groupApplyState("Ref_Server");
      window.scene.groupApplyState("Front_Panel_OFF");
      GotoPosInTimeNamedValue(window.config.default5U,function () {
      });

      document.getElementById("hotspot1").setAttribute("tabindex","-1");
      document.getElementById("hotspot2").setAttribute("tabindex","-1");
      document.getElementById("hotspot3").setAttribute("tabindex","-1");
      document.getElementById("hotspot4").setAttribute("tabindex","-1");
      document.getElementById("hotspot5").setAttribute("tabindex","-1");
      document.getElementById("hotspot6").setAttribute("tabindex","-1");
      document.getElementById("hotspot7").setAttribute("tabindex","-1");
      document.getElementById("hotspot8").setAttribute("tabindex","-1");
      document.getElementById("hotspot9").setAttribute("tabindex","-1");
      document.getElementById("hotspot10").setAttribute("tabindex","-1");

      document.getElementById("hotspot11").setAttribute("tabindex","-1");
      document.getElementById("hotspot12").setAttribute("tabindex","-1");
      document.getElementById("hotspot13").setAttribute("tabindex","-1");

   }
   const onFanClick = (isNextPrevious) => {

      console.log("storage processor");
      //reverseAnim();
      reverseState();
      document.getElementById('performance').style.display = 'none';
      document.getElementById('controller_memory').style.display = 'none';
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      hideSoftwareImg();
      window.document.getElementById('fanBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      selectedButton = 'onFanClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Fan');

         document.getElementById('nextView').setAttribute('aria-label','Fan');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      window.scene.clearRefine();

         if(server1){
            GotoPosInTimeNamedValue(window.config.right,function () {
               document.getElementById('storage_processor').style.display = 'block';
            window.scene.animPlayInTime("DELL_POWER_VAULT_4591",0.41,1000);
            window.scene.groupApplyState("Internal_24_NEW_OFF");
            window.scene.groupApplyState("Internal_12_NEW_ON");
            window.scene.animPlayInTime("BEZEL",0.41,1000);
            window.scene.groupApplyState("Server_OFF");
            setTimeout(function () { 
               window.scene.groupApplyState("Top_OFF");
             },1000);
             if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         }
         else if(server2){
            GotoPosInTimeNamedValue(window.config.right,function () {
               document.getElementById('storage_processor').style.display = 'block';
            window.scene.animPlayInTime("DELL_POWER_VAULT_4591",0.41,1000);
            window.scene.groupApplyState("Internal_12_NEW_OFF");
            window.scene.groupApplyState("Internal_24_NEW_ON");
            window.scene.animPlayInTime("BEZEL",0.41,1000);
            window.scene.groupApplyState("Server_OFF");
            setTimeout(function () { 
               window.scene.groupApplyState("Top_OFF");
             },1000);
             if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         }
         else if(server3){
            GotoPosInTimeNamedValue(window.config.right5U,function () {
               document.getElementById('storage_processor').style.display = 'block';
            window.scene.groupApplyState("Server_ON");
            window.scene.groupApplyState("Top_OFF");
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         } 
         

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Interior","Fans",window.config.name);

      window.scene.clearRefine();

   }

   //Menu Software   
   const onSoftwareClick = (isNextPrevious) => {

      

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      hideSoftwareImg();

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();
      hideSoftwareImg();

      selectedButton = 'onSoftwareClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Software');

         document.getElementById('nextView').setAttribute('aria-label','Software');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
         window.scene.groupApplyState("Front_Panel_ON");
         window.scene.groupApplyState("Power_Vault_12_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_OFF");
         window.scene.groupApplyState("Front_Panel_ON");
         window.scene.groupApplyState("Power_Vault_12_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
         window.scene.groupApplyState("Power_Vault_12_OFF");
      } 
      if(server1){
         GotoPosInTimeNamedValue(window.config.software,function () {
            window.localStorage.setItem('hotspot','software');
         });
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.software,function () {
            window.localStorage.setItem('hotspot','software');
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.software5U,function () {
            window.localStorage.setItem('hotspot','software');
         });
      } 


      window.scene.clearRefine();

   }
   const embeddedManagementClick = (isNextPrevious) => {

      //Update ZoomBar

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      reverseAnim();
      reverseState();
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById("openManagmentTool").style.display = 'none';
      document.getElementById("dataOptimizaion").style.display = 'none';
      document.getElementById("dataMobilityTitleDiv").style.display = 'none';
      document.getElementById("dataProtectionTitleDiv").style.display = 'none';

      document.getElementById("virtualizationTitleDiv").style.display = 'none';

      window.document.getElementById('embededBtn').classList.add('active');
      window.localStorage.setItem("position","reset");


      selectedButton = 'embeddedManagementClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Storage Management & Scripting');

         document.getElementById('nextView').setAttribute('aria-label','Storage Management & Scripting');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
         
      }
      else if(server2){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
      } 


      

      if(server1){
         GotoPosInTimeNamedValue(window.config.software,function () {
         
            if (window.mob || window.isipad) {
               // document.getElementById('calloutcanvas').style.display = "block";
               document.getElementById("embadedManagment").style.display = 'none';
               window.localStorage.setItem('hotspot','embedded');
            } else {
               // document.getElementById('calloutcanvas').style.display = "block";
               document.getElementById("embadedManagment").style.display = 'block';
               window.localStorage.setItem('hotspot','embedded');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
         
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.software,function () {
         
            if (window.mob || window.isipad) {
               // document.getElementById('calloutcanvas').style.display = "block";
               document.getElementById("embadedManagment").style.display = 'none';
               window.localStorage.setItem('hotspot','embedded');
            } else {
               // document.getElementById('calloutcanvas').style.display = "block";
               document.getElementById("embadedManagment").style.display = 'block';
               window.localStorage.setItem('hotspot','embedded');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.software5U,function () {
         
            if (window.mob || window.isipad) {
               // document.getElementById('calloutcanvas').style.display = "block";
               document.getElementById("embadedManagment").style.display = 'none';
               window.localStorage.setItem('hotspot','embedded');
            } else {
               // document.getElementById('calloutcanvas').style.display = "block";
               document.getElementById("embadedManagment").style.display = 'block';
               window.localStorage.setItem('hotspot','embedded');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      } 


      if (!(window.isipad || window.mob)) {
         document.getElementById("text-embed-one").setAttribute("tabindex","0");
         document.getElementById("text-embed-two").setAttribute("tabindex","0");
         document.getElementById("text-embed-three").setAttribute("tabindex","0");
         document.getElementById("text-embed-four").setAttribute("tabindex","0");
         document.getElementById("text-embed-five").setAttribute("tabindex","0");

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Software","Storage Management & Scripting",window.config.name);

      window.scene.clearRefine();

   }

   const openManageToolsClick = (isNextPrevious) => {

      //Update ZoomBar

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById("embadedManagment").style.display = 'none';
      document.getElementById("dataOptimizaion").style.display = 'none';
      document.getElementById("dataProtectionTitleDiv").style.display = 'none';

      document.getElementById("virtualizationTitleDiv").style.display = 'none';
      window.document.getElementById('openManageBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();

      selectedButton = 'openManageToolsClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','OpenManage Tools');

         document.getElementById('nextView').setAttribute('aria-label','OpenManage Tools');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
      } 
      if(server1){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("openManagmentTool").style.display = 'none';
               window.localStorage.setItem('hotspot','openManage');
            } else {
               document.getElementById("openManagmentTool").style.display = 'block';
               // window.localStorage.setItem('hotspot','openManage');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("openManagmentTool").style.display = 'none';
               window.localStorage.setItem('hotspot','openManage');
            } else {
               document.getElementById("openManagmentTool").style.display = 'block';
               // window.localStorage.setItem('hotspot','openManage');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.software5U,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("openManagmentTool").style.display = 'none';
               window.localStorage.setItem('hotspot','openManage');
            } else {
               document.getElementById("openManagmentTool").style.display = 'block';
               // window.localStorage.setItem('hotspot','openManage');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      } 

      if (!(window.isipad || window.mob)) {
         document.getElementById("text-opn-one").setAttribute("tabindex","0");
         document.getElementById("text-opn-two").setAttribute("tabindex","0");
         // document.getElementById("text-opn-three").setAttribute("tabindex","0");

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Software","OpenManage Tools",window.config.name);

      window.scene.clearRefine();

   }
   const ondataOptClick = (isNextPrevious) => {

      //Update ZoomBar

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById("openManagmentTool").style.display = 'none';
      document.getElementById("embadedManagment").style.display = 'none';
      document.getElementById("dataProtectionTitleDiv").style.display = 'none';
      document.getElementById("dataMobilityTitleDiv").style.display = 'none';
      document.getElementById("virtualizationTitleDiv").style.display = 'none';
      window.document.getElementById('dataOptimization').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();

      selectedButton = 'ondataOptClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Data Optimization');

         document.getElementById('nextView').setAttribute('aria-label','Data Optimization');
      }

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
      } 


      

      if(server1){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataOptimizaion").style.display = 'none';
               window.localStorage.setItem('hotspot','dataOptimization');
            } else {
               document.getElementById("dataOptimizaion").style.display = 'block';
                window.localStorage.setItem('hotspot','dataOptimization');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataOptimizaion").style.display = 'none';
               window.localStorage.setItem('hotspot','dataOptimization');
            } else {
               document.getElementById("dataOptimizaion").style.display = 'block';
                window.localStorage.setItem('hotspot','dataOptimization');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.software5U,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataOptimizaion").style.display = 'none';
               window.localStorage.setItem('hotspot','dataOptimization');
            } else {
               document.getElementById("dataOptimizaion").style.display = 'block';
                window.localStorage.setItem('hotspot','dataOptimization');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      } 

      if (!(window.isipad || window.mob)) {
         document.getElementById("text-data-opt-one").setAttribute("tabindex","0");
         document.getElementById("text-data-opt-two").setAttribute("tabindex","0");
         document.getElementById("text-data-opt-three").setAttribute("tabindex","0");
         document.getElementById("text-data-opt-four").setAttribute("tabindex","0");
         document.getElementById("text-data-opt-five").setAttribute("tabindex","0");

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Software","OpenManage Tools",window.config.name);

      window.scene.clearRefine();

   }
   const dataMobilityClick = (isNextPrevious) => {

      //Update ZoomBar

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById("embadedManagment").style.display = 'none';
      document.getElementById("openManagmentTool").style.display = 'none';
      document.getElementById("dataOptimizaion").style.display = 'none';
      document.getElementById("dataProtectionTitleDiv").style.display = 'none';
      document.getElementById("virtualizationTitleDiv").style.display = 'none';
      // document.getElementById("dataMobilityTitleDiv").style.display = 'none';


      window.document.getElementById('dataMobilityMigration').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();

      selectedButton = 'dataMobilityClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','OpenManage Tools');

         document.getElementById('nextView').setAttribute('aria-label','OpenManage Tools');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
      } 


     
      if(server1){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataMobilityTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','dataMob');
            } else {
               document.getElementById("dataMobilityTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','dataMob');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataMobilityTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','dataMob');
            } else {
               document.getElementById("dataMobilityTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','dataMob');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.software5U,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataMobilityTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','dataMob');
            } else {
               document.getElementById("dataMobilityTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','dataMob');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      } 

      if (!(window.isipad || window.mob)) {
         document.getElementById("mobility-text-opn-one").setAttribute("tabindex","0");
         document.getElementById("mobility-text-opn-two").setAttribute("tabindex","0");

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Software","OpenManage Tools",window.config.name);

      window.scene.clearRefine();

   }
   const dataProtectionClick = (isNextPrevious) => {

      //Update ZoomBar

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById("embadedManagment").style.display = 'none';
      document.getElementById("openManagmentTool").style.display = 'none';
      document.getElementById("dataOptimizaion").style.display = 'none';
      document.getElementById("dataMobilityTitleDiv").style.display = 'none';
      document.getElementById("dataProtectionTitleDiv").style.display = 'none';
      document.getElementById("virtualizationTitleDiv").style.display = 'none';
      window.document.getElementById('dataProtection').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();

      selectedButton = 'dataProtectionClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','OpenManage Tools');

         document.getElementById('nextView').setAttribute('aria-label','OpenManage Tools');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
      } 
      if(server1){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataProtectionTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','dataProtection');
            } else {
               document.getElementById("dataProtectionTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','dataProtection');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataProtectionTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','dataProtection');
            } else {
               document.getElementById("dataProtectionTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','dataProtection');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.software5U,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("dataProtectionTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','dataProtection');
            } else {
               document.getElementById("dataProtectionTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','dataProtection');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      } 

      if (!(window.isipad || window.mob)) {
         document.getElementById("data-protection-text-opn-one").setAttribute("tabindex","0");
         document.getElementById("data-protection-text-opn-two").setAttribute("tabindex","0");

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Software","OpenManage Tools",window.config.name);

      window.scene.clearRefine();

   }
   const virtualizationClick = (isNextPrevious) => {

      //Update ZoomBar
      // alert("virtualizationClick");
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById("embadedManagment").style.display = 'none';
      document.getElementById("openManagmentTool").style.display = 'none';
      document.getElementById("dataOptimizaion").style.display = 'none';
      document.getElementById("dataProtectionTitleDiv").style.display = 'none';
      document.getElementById("dataMobilityTitleDiv").style.display = 'none';

      window.document.getElementById('Virtualization').classList.add('active');
      window.localStorage.setItem("position","reset");
      reverseAnim();
      reverseState();

      selectedButton = 'virtualizationClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Virtualization');

         document.getElementById('nextView').setAttribute('aria-label','Virtualization');
      }
      window.scene.groupApplyState("all_GP_off");

      window.localStorage.removeItem('hotspot');

      if(server1){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server2){
         window.scene.groupApplyState("Top_ON");
      }
      else if(server3){
         window.scene.groupApplyState("Top_OFF");
      } 


      
      if(server1){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("virtualizationTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','virtualization');
            } else {
               document.getElementById("virtualizationTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','virtualization');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server2){
         GotoPosInTimeNamedValue(window.config.software,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("virtualizationTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','virtualization');
            } else {
               document.getElementById("virtualizationTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','virtualization');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      }
      else if(server3){
         GotoPosInTimeNamedValue(window.config.software5U,function () {
            // document.getElementById('calloutcanvas').style.display = "block";
            if (window.mob || window.isipad) {
               document.getElementById("virtualizationTitleDiv").style.display = 'none';
               window.localStorage.setItem('hotspot','virtualization');
            } else {
               document.getElementById("virtualizationTitleDiv").style.display = 'block';
                window.localStorage.setItem('hotspot','virtualization');
            }
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo2").focus();
            }
         });
      } 

      if (!(window.isipad || window.mob)) {
         document.getElementById("text-virtul-one").setAttribute("tabindex","0");
         document.getElementById("text-virtul-two").setAttribute("tabindex","0");
         document.getElementById("text-virtul-three").setAttribute("tabindex","0");
         document.getElementById("text-virtul-four").setAttribute("tabindex","0");

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Software","Virtualization",window.config.name);

      window.scene.clearRefine();

   }

   const pivotAnimation = () => {
      console.log("pivotAnimation");

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('pivotBtn').classList.add('active');

      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Pivot Monitor 90°');

         document.getElementById('nextView').setAttribute('aria-label','Pivot Monitor 90°');
      }


      window.localStorage.setItem("position","reset");

      selectedButton = 'pivotAnimation';

      setTimeout(function () {
         window.localStorage.removeItem('hotspot');
      },1000)
      GotoPosInTimeNamedValue('Render_Cam_F15_F_NEW',function () {
         window.scene.groupApplyState('90_degree_on');
         window.scene.animPlayAllChildrenInTime("swivel_rotation",0.833333,1,function () {

            window.scene.animPlayAllChildrenInTime("swivel_rotation",1.666,10000,function () {
               // GotoPosInTimeNamedValue('Render_Cam_F15_F', function () {
               animComplete();
               // });
            });
            window.scene.clearRefine();
         });

      });
      window.scene.clearRefine();

   }
   const swivelAnimation = () => {
      //Update ZoomBar
      console.log("swivelAnimation");

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('swivelBtn').classList.add('active');

      selectedButton = 'swivelAnimation';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Swivel base 45°');

         document.getElementById('nextView').setAttribute('aria-label','Swivel base 45°');
      }

      window.localStorage.setItem("position","reset");

      window.localStorage.removeItem('hotspot');

      setTimeout(function () {

         window.localStorage.removeItem('hotspot');
      },1000)
      GotoPosInTimeNamedValue('Render_Cam_F15_Top',function () {
         window.scene.groupApplyState('45_Degree_on');
         // window.scene.animPlayInTime("hing_move", 0.1, 1000, function (){
         window.scene.animPlayInTime("swivel_rotation",1,5000,function () {
            animComplete();
         });
         // });
      })
      window.scene.clearRefine();

   }

   const heightAnimation = () => {
      //Update ZoomBar
      console.log("heightAnimation");

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Adjust Height 130mm');

         document.getElementById('nextView').setAttribute('aria-label','Adjust Height 130mm');
      }

      window.localStorage.removeItem('hotspot');

      selectedButton = 'heightAnimation';

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('heightBtn').classList.add('active');

      window.localStorage.setItem("position","reset");
      setTimeout(function () {
         window.localStorage.removeItem('hotspot');
      },1000)
      GotoPosInTimeNamedValue('Render_Cam_F15_Rear',function () {
         window.scene.groupApplyState('mm_130_on');

         window.scene.animPlayInTime("hing_move",0.775,3000,function () {
            animComplete();
         });
      });
      window.scene.clearRefine();
   }


   const tiltScreenAnimation = () => {
      //Update ZoomBar
      console.log("tiltScreenAnimation");

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Tilt Screen 21°/-5°');

         document.getElementById('nextView').setAttribute('aria-label','Tilt Screen 21°/-5°');
      }
      selectedButton = 'tiltScreenAnimation';
      window.localStorage.removeItem('hotspot');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('tiltScreenBtn').classList.add('active');

      window.localStorage.setItem("position","reset");
      setTimeout(function () {
         console.log("serTimeout");
         window.localStorage.removeItem('hotspot');
      },1000)
      GotoPosInTimeNamedValue('Render_Cam_F16_R_NEW',function () {
         window.scene.groupApplyState('21and5_Degree_on');
         window.scene.animPlayInTime("hinge_rotate",0.87,3000,function () {
            animComplete();
         });
         window.scene.clearRefine();
      });

      window.scene.clearRefine();
   }




   const resetMode = () => {
      selectedButton = 'onResetMode';
      window.localStorage.removeItem('hotspot');
      GotoPosInTimeNamedValue(window.config.default,function ()  {
         window.scene.groupApplyState("Top_Cover_Unhide");
      });
      selectedButton = 'onResetMode';
   }
   const onResetMode = () => {
      //Update ZoomBar

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (selectedButton == 'onExteriorClick') {
         onExteriorClick();

      }
      else if (selectedButton == 'FrontModeClick') {
         FrontModeClick();

      }
      else if (selectedButton == 'RearModeClick') {
         RearModeClick();

      }
      // else if (selectedButton == 'DimensionClick') {
      //    DimensionClick();
      // }
      else if (selectedButton == 'onInterirorClick') {
         console.log("interier onreset")

         onInterirorClick();
      }
      else if (selectedButton == 'onProcessorClick') {

         onProcessorClick();
      }
      else if (selectedButton == 'onMemoryClick') {

         onMemoryClick();
      }
      else if (selectedButton == 'onFanClick') {
         onFanClick();


      } else if (selectedButton == 'onSoftwareClick') {
         onSoftwareClick();


      }
      else if (selectedButton == 'embeddedManagementClick') {
         embeddedManagementClick();

      }
      else if (selectedButton == 'openManageToolsClick') {
         openManageToolsClick();
         
      }

      else if (selectedButton == 'ondataOptClick') {
         ondataOptClick();
      }

      else if (selectedButton == 'dataProtectionClick') {
         dataProtectionClick();
      }

      else if (selectedButton == 'dataMobilityClick') {
         dataMobilityClick();
      }

      else if (selectedButton == 'virtualizationClick') {
         virtualizationClick();
      }
      else if (selectedButton == 'server1Click') {
         GotoPosInTimeNamedValue(window.config.default,function () {
           // // document.getElementById('calloutcanvas').style.display = "block";
            window.scene.groupApplyState("Power_Vault_24_OFF");
            window.scene.groupApplyState("Power_Vault_12_ON");
            window.scene.groupApplyState("Ref_Vault_12");
            window.scene.groupApplyState("GP_12");
         });

      }
      else if (selectedButton == 'server2Click') {
         GotoPosInTimeNamedValue(window.config.default,function () {
            window.scene.groupApplyState("Power_Vault_12_OFF");
            window.scene.groupApplyState("Power_Vault_24_ON");
            window.scene.groupApplyState("Ref_Vault_24");
            window.scene.groupApplyState("GP_24");
         });

      }
      else if (selectedButton == 'server3Click') {
         GotoPosInTimeNamedValue(window.config.default5U,function () {
            window.scene.groupApplyState("Server_ON");
            window.scene.groupApplyState("Power_Vault_24_OFF");
         window.scene.groupApplyState("Power_Vault_12_OFF");
         window.scene.groupApplyState("GP_Server");
         window.scene.groupApplyState("Ref_Server");
         });

      }


      else if (selectedButton == 'onResetMode') {
         resetMode()
         GotoPosInTimeNamedValue(window.config.default,function ()  {
            window.scene.groupApplyState("Top_Cover_Unhide");
         });
      }

      window.scene.clearRefine();


   }

   const onPreviousMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      // alert(selectedButton)
      var prevButton;

      var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
      if (selectedButton == 'onExteriorClick' || selectedButton == 'onResetMode') {
         prevButton = 'virtualizationClick';
         setExpandedPanel("panel3");
      } else {
         prevButton = buttonSeq[selectedButtonIndex - 1];
      }
      // }
      // alert(buttonSeq[selectedButtonIndex+1])


      if (prevButton == 'onExteriorClick') {
         onExteriorClick(true);
         setExpandedPanel("panel2");
      }

      else if (prevButton == 'FrontModeClick') FrontModeClick(true);
      else if (prevButton == 'RearModeClick') {
         setExpandedPanel("panel2");
         RearModeClick(true);
      }
      else if (prevButton == 'onInterirorClick') {
         setExpandedPanel("panel6");
         onInterirorClick(true);
      }
      else if (prevButton == 'onProcessorClick') onProcessorClick(true);

      else if (prevButton == 'onMemoryClick') onMemoryClick(true);

      else if (prevButton == 'onFanClick') {
         onFanClick(true);
         setExpandedPanel("panel6");

      }
      else if (prevButton == 'onSoftwareClick') {
         setExpandedPanel("panel3");
         onSoftwareClick(true);
      }

      else if (prevButton == 'embeddedManagementClick') embeddedManagementClick(true);
      else if (prevButton == 'openManageToolsClick') {
         // setExpandedPanel("panel2");
         openManageToolsClick(true);
      }
      else if (prevButton == 'ondataOptClick') ondataOptClick(true);
      else if (prevButton == 'dataMobilityClick') dataMobilityClick(true);
      else if (prevButton == 'dataProtectionClick') dataProtectionClick(true);
      else if (prevButton == 'virtualizationClick') {
         setExpandedPanel("panel3");
         virtualizationClick(true);
      }

      return false;


   }


   const onNextMode = () => {
      console.log('next')
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      // if(laptop180){


      var nextButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
      if (selectedButton == 'virtualizationClick') {
         nextButton = 'onExteriorClick';
      } else {
         nextButton = buttonSeq[selectedButtonIndex + 1];
      }
      // }
      // alert(laptop180)
      if (nextButton == 'onExteriorClick') {
         onExteriorClick(true);
         setExpandedPanel("panel2");
      }


      else if (nextButton == 'FrontModeClick') FrontModeClick(true);
      else if (nextButton == 'RearModeClick') RearModeClick(true);
      else if (nextButton == 'onInterirorClick') {
         setExpandedPanel("panel6");
         onInterirorClick(true);
      }
      else if (nextButton == 'onProcessorClick') onProcessorClick(true);

      else if (nextButton == 'onMemoryClick') onMemoryClick(true);
      else if (nextButton == 'onMemoryClick') onMemoryClick(true);

      else if (nextButton == 'onFanClick') onFanClick(true);
      else if (nextButton == 'onSoftwareClick') {
         setExpandedPanel("panel3");
         onSoftwareClick(true);
      }
      else if (nextButton == 'embeddedManagementClick') embeddedManagementClick(true);
      else if (nextButton == 'openManageToolsClick') {
         // setExpandedPanel("panel2");
         openManageToolsClick(true);
      }
      else if (nextButton == 'ondataOptClick') ondataOptClick(true);
      else if (nextButton == 'dataMobilityClick') dataMobilityClick(true);
      else if (nextButton == 'dataProtectionClick') dataProtectionClick(true);
      else if (nextButton == 'virtualizationClick') {
         // setExpandedPanel("panel5");
         virtualizationClick(true);
      }

      return false;


   }

   // useEffect(()=>{
   //   getData();

   // },[counter])
   const [animValue,setAnimValue] = useState("On");
   const [animValue1,setAnimValue1] = useState("On");
   // window.localStorage.setItem('Animation', 'on');
   useEffect(() => {
      window.localStorage.setItem('Animation','on');
      document.getElementById("animSwitchValue").checked = 'true';

      setAnimValue("On");
      document.getElementsByClassName('onOff')[0].style.left = "-17px";

      setAnimValue1("On");
      document.getElementById("animSwitchValue1").checked = true;
      document.getElementsByClassName('onOff1')[0].style.left = "-17px";

   },[]);


   const setAnimationSwitch = (e) => {
      console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation Off');
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.localStorage.setItem('Animation','off');

         window.RT_RecordEvent("Animations","Off",window.config.name);
         //   document.getElementById('animSwitchValue').setAttribute('aria-label', '');
         // document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On';
         // alert("Animation On");

      } else {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation On')
         document.getElementById("animSwitchValue").checked = true;

         setAnimValue("On");
         window.localStorage.setItem('Animation','on');
         document.getElementsByClassName('onOff')[0].style.left = "-17px";

         window.RT_RecordEvent("Animations","On",window.config.name);
         // alert("Animation Off");
         //   document.getElementById('animSwitchValue').setAttribute('aria-label', '');
         // document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off';
      }
   }
   const displayName = (e) => {
      console.log(e)
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         setAnimValue("On");
         window.localStorage.setItem('Animation','on');
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On';
         // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked On');
         // alert("Animation On");

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.localStorage.setItem('Animation','off');
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off';
         // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked Off');
         // alert("Animation Off");

      }

   }
   const setAnimationSwitch1 = (e) => {
      console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue1").checked = false;
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         // window.localStorage.setItem('Animation1','off');
         window.animationSwitchVal = 'off';
         window.animationSwitchGlobal = 'off';


      } else {
         // document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation On')
         document.getElementById("animSwitchValue1").checked = true;

         setAnimValue1("On");
         window.animationSwitchVal = 'on';
         // keyboardOn();
         // window.localStorage.setItem('Animation1','on');
         window.animationSwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";

      }


   }
   var animStopped = true;
   const displayName1 = (e) => {
      if (animStopped == false) {
         return;
         animStopped = false;
      }
      console.log(e)
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         setAnimValue1("On");
         // keyboardOn();
         // window.localStorage.setItem('Animation1','on');
         window.animation1SwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
         window.animationSwitchVal = 'on';

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'block';
         }
         else if (isipad) {
            console.log('portrait');
            document.getElementById('footerControMob').style.display = 'block';
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            console.log("show");

            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "20px";
            /*  document.getElementById('footerControMob').style.transition = "bottom 0.2s linear";
             document.getElementById('footerControMob').style.bottom = "20px"; */

            document.getElementById('footerControls').style.visibility = "";
            document.getElementById('footerControIpad').style.visibility = "";
            //document.getElementById('footerControMob').style.visibility = "";

         }


      } else {
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         // window.localStorage.setItem('Animation1','off');
         window.animation1SwitchGlobal = 'off';

         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked Off');

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'none';
         } else if (isipad) {
            console.log('landscape');
            document.getElementById('footerControMob').style.display = 'none';
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            console.log("hide");
            //document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "-112px";
            /*  document.getElementById('footerControMob').style.transition = "bottom 0.24s linear";
             document.getElementById('footerControMob').style.bottom = "-49px"; */
            setTimeout(function () {

               document.getElementById('footerControls').style.visibility = "hidden";
               document.getElementById('footerControIpad').style.visibility = "hidden";

               //document.getElementById('footerControMob').style.visibility = "hidden";

               animStopped = true;
            },150);
         }

      }

   }


   return (
      <>
         {!mob && <HowToUse />}
         <Hidden only={['sm','md','lg','xl']}>

            <Button style={{ position: 'fixed',backgroundColor: '#F0F0F0',width: '100%',height: '56px',paddingTop: '15px',paddingBottom: '15px',zIndex: '1',border: '1px solid #E1E1E1',borderLeft: "none",borderRight: "none",borderRadius: "0",margin: "-1px 0px 0px 0px" }}
               variant="outlined"
               color="primary"
               // className={classes.button}
               endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px',height: '23px' }} />}
               onClick={props.toggleDrawerAction}
            >
               Main Menu
            </Button>
            <Howtousenew />

         </Hidden>
         <Hidden only={['md','lg','xl','xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" onReset={onResetMode} onPrevious={onPreviousMode} onNext={onNextMode} />
         </Hidden>
         <Hidden only={['lg','xl']}>
            <FooterControlMob onResetMob={onResetMode} onPreviousMob={onPreviousMode} onNextMob={onNextMode} onResetIpad={onResetMode} onNextIpad={onNextMode} onPreviousIpad={onPreviousMode} />
         </Hidden>
         <MenuSelectProductType tabIndex="1" name="Select Product Type" onclicked={server1Click} onclickedtwo={server2Click} onclickedthree={server3Click} value={value} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')} /> 
         {/* <userContext.Provider value=""> */}
         {/* <MenuColors id="menuColor" tabIndex="1" name="Colors" onWhiteBtnClick={color1Click} onBlackBtnClick={color2Click} expanded={expandedPanel === 'panel4'} onChanged={handleAccordionChange('panel4')} /> */}
         {/* </userContext.Provider> */}
         {/* <MenuPositions name="Adjustability" tabIndex="1" onTentMode={TentModeClick} onTheaterMode={TheaterModeClick} onTabletMode={TabletModeClick} expanded={expandedPanel === 'panel2'} onChanged={handleAccordionChange('panel2')}/> */}

         <MenuExteriorView name="Exterior" tabIndex="1" onExterior={onExteriorClick} onFrontMode={FrontModeClick} onRearMode={RearModeClick} expanded={expandedPanel === 'panel2'} imgfront={frontImg} imgrear={rearImg} onChanged={handleAccordionChange('panel2')} />


         <MenuInterierView name="Internal" tabIndex="1" onProcessorBtnClick={onProcessorClick} onMemoryBtnClick={onMemoryClick} onFanBtnClick={onFanClick} onInterirorBtnClick={onInterirorClick} imgStorageProcessor={storageProcessorImg} imgControllerMemory={controllerMemoryImg} expanded={expandedPanel === 'panel6'} onChanged={handleAccordionChange('panel6')} />

         <MenuSoftware name="Software" tabIndex="1" onEmbeddedManagementClicked={embeddedManagementClick} onOpenManageToolsClicked={openManageToolsClick} ondataOptimizationClicked={ondataOptClick} ondataMobilityMigrationClicked={dataMobilityClick} ondataProtectionClicked={dataProtectionClick} onVirtualizationClicked={virtualizationClick} onSoftware={onSoftwareClick} expanded={expandedPanel === 'panel3'} onChanged={handleAccordionChange('panel3')} />

         <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} onchange1={displayName1} forKeypress1={setAnimationSwitch1} value1={animValue1} />

      </>
   );
}

export default MainMenu;